__turbopack_context__.v({
  "accordionSlideOverwrite": "mobileMenu-module-scss-module__sOIzBW__accordionSlideOverwrite",
  "actions": "mobileMenu-module-scss-module__sOIzBW__actions",
  "close": "mobileMenu-module-scss-module__sOIzBW__close",
  "demoButton": "mobileMenu-module-scss-module__sOIzBW__demoButton",
  "fadeIn": "mobileMenu-module-scss-module__sOIzBW__fadeIn",
  "fadeOut": "mobileMenu-module-scss-module__sOIzBW__fadeOut",
  "header": "mobileMenu-module-scss-module__sOIzBW__header",
  "links": "mobileMenu-module-scss-module__sOIzBW__links",
  "login": "mobileMenu-module-scss-module__sOIzBW__login",
  "menu": "mobileMenu-module-scss-module__sOIzBW__menu",
  "scaleIn": "mobileMenu-module-scss-module__sOIzBW__scaleIn",
  "scaleOut": "mobileMenu-module-scss-module__sOIzBW__scaleOut",
  "trigger": "mobileMenu-module-scss-module__sOIzBW__trigger",
  "zoomIn": "mobileMenu-module-scss-module__sOIzBW__zoomIn",
  "zoomOut": "mobileMenu-module-scss-module__sOIzBW__zoomOut",
});
